import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionHistoryItem = ({ transaction }) => {
  const getTypeIcon = (type) => {
    switch (type) {
      case 'deposit':
        return 'ArrowDownToLine';
      case 'withdrawal':
        return 'ArrowUpFromLine';
      case 'transfer':
        return 'ArrowRightLeft';
      default:
        return 'DollarSign';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'deposit':
        return 'text-[var(--color-success)]';
      case 'withdrawal':
        return 'text-[var(--color-warning)]';
      default:
        return 'text-[var(--color-foreground)]';
    }
  };

  const getStatusBadge = (status) => {
    const styles = {
      completed: 'bg-[var(--color-success)] bg-opacity-10 text-[var(--color-success)]',
      pending: 'bg-[var(--color-warning)] bg-opacity-10 text-[var(--color-warning)]',
      failed: 'bg-[var(--color-error)] bg-opacity-10 text-[var(--color-error)]',
      processing: 'bg-[var(--color-brand-trust)] bg-opacity-10 text-[var(--color-brand-trust)]'
    };

    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${styles?.[status]}`}>
        {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
      </span>
    );
  };

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-lg p-4 hover:shadow-md transition-shadow duration-300">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className={`w-10 h-10 rounded-lg bg-opacity-10 flex items-center justify-center flex-shrink-0 ${getTypeColor(transaction?.type)} bg-current`}>
            <Icon name={getTypeIcon(transaction?.type)} size={20} className={getTypeColor(transaction?.type)} />
          </div>
          
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <h4 className="text-sm md:text-base font-semibold text-[var(--color-foreground)]">
                {transaction?.description}
              </h4>
              <span className={`text-sm md:text-base font-bold ${getTypeColor(transaction?.type)} whitespace-nowrap`}>
                {transaction?.type === 'withdrawal' ? '-' : '+'}${transaction?.amount?.toLocaleString()}
              </span>
            </div>
            
            <p className="text-xs md:text-sm text-[var(--color-muted-foreground)] mt-1">
              {transaction?.method}
            </p>
            
            <div className="flex items-center gap-3 mt-2 flex-wrap">
              {getStatusBadge(transaction?.status)}
              <span className="text-xs text-[var(--color-muted-foreground)]">
                {transaction?.date}
              </span>
              {transaction?.transactionId && (
                <span className="text-xs text-[var(--color-muted-foreground)]">
                  ID: {transaction?.transactionId}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      {transaction?.estimatedCompletion && transaction?.status === 'processing' && (
        <div className="mt-3 pt-3 border-t border-[var(--color-border)]">
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
            <p className="text-xs text-[var(--color-muted-foreground)]">
              Estimated completion: {transaction?.estimatedCompletion}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionHistoryItem;